<template lang="pug">
  .scroll-bar
    svg(viewBox="0 0 6 256" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none")
      path(:transform="`translate(0 ${256*(1-ratio)*p+overflowOfs}) scale(1 ${ratio-overflow})`" d="M5.2 185.4l-.2-.2c0-3.1.2-.9.2-3.8-.3-1 0-4.7 0-5.6v-3.5l-.1.4v-2-.2l.2-35.7c-.1.7 0 2.5-.2 3.1V135c.2-.6 0-3.3.3-4.4l-.2-.5.1-.6V122c0-3.4-.2-5-.1-6.7 0 .2-.1 1.1-.2.2.2-.2 0-2.2 0-2.6 0-1 0-3.6-.1-2.7 0-.5.1-3 .2-1.6v-2.2 1.1l-.1-6.2-.1 1 .1-3.7v-4.9.9c-.2-3-.3-18.3-.5-21V75l-.2-2.2.4 1.3V38.5c0-1.8.2-.3.2-.3 0-2.2-.2-.9-.2-2.9 0-.4.1 0 .2.5V34c-.1 1.1-.3.7-.4 1.1v-2.4h.1c0-.5-.2-1.4-.2-3.8v-13l.2 1.8v-2-.9c-.2-1.6-.2-3.1-.2-5.3 0-2 0-4-.2-5.8 0 0-1-1.4-1.9-.5-.2.2-.5.5-.6.9l-.1.4-.1.3.1-.7.2-.7v-.2-.4l.1-.3v.3c0 .2-.1.9-.3 1.3v.2l-.5 1.4v.2l-.2.4-.2.3v.2s-.1.2 0 0l.4-1 .7-2.4-.1.7-.1.2v.2l-.3.5c0 .2 0 .4-.2.7l-.3.9-.2.2V7c-.1 0 0 0 0 0-.1.2-.2 0-.2.4v1.8c0 1.8.2 4 .1 6.7v-.2 11.8L.8 72v-.2c0 11.4 0 34.8.2 46.6l-.2 6.2c0-1 .2-.6.2.3v6.2c.2 6.7 0 32.6 0 38.6v10.5-.2 26.5-.4 5.5l.2 3.8.2 8.3h-.1V247l-.3 3.3v.5s3.2 5.3 4-1.3V248 246v2.2c0-1.5.1-.4.2.2v-1.7c-.2-1.4-.2-.7-.2-.5 0-.9-.2-2-.1-3.1l.1-2c.1-10.3.3-20 .2-30.4v-8.2c0-.9.1-.9.2-1.3l-.1-7.6v-5.6-2.5z" fill="#F8DEB1")



</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import Raf from 'src/helpers/Raf'
export default {
  name: 'scroll-bar',
  props: {
    progress: {
      required: true,
      default: 0,
    },
    ratio: {
      required: true,
      default: 1,
    },
  },
  components: {},
  data() {
    return {
      overflow: 0,
      overflowOfs: 0,
      p: 0,
      of: 0,
      ofs: 0,
      pp: 0
    }
  },
  computed: {
    ...mapState('app', ['seenIntro']),
    ...mapState('browser', ['windowWidth', 'windowHeight']),
  },
  mounted() {
    //Raf.add(this.update)
  },
  beforeDestroy() {
    //Raf.remove(this.update)
  },
  methods: {
    // update() {
    //   let dp = this.p-this.pp
    //   let r = 1
    //   let v = 0.15
    //   this.pp += dp*r*v
    //   this.of += (this.overflow-this.of)*r*v
    //   this.ofs += (this.overflowOfs-this.ofs)*r*v
    // },
  },
  watch: {
    progress(val){
      if (val > 1){
        this.overflow = (val - 1)*0.1
        this.overflowOfs = this.overflow*256
        this.p = 1
        return
      }
      if (val < 0){
        this.overflow = (0 - val)*0.1
        this.p = 0
        return
      }
      this.overflow = 0
      this.overflowOfs = 0
      this.p = val
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"


.scroll-bar
  position: absolute
  width: 0.1rem
  height: 100%
  top: 0
  right: 0
  //background: #e15125
  svg
    width: 100%
    height: 100%
  //background: #3a602e
  //.bar
    .fg
      g
        fill: white
    svg
      transform: rotateZ(90deg)
      width: 100%





</style>
